export enum BdcClosePropertyReason {
  Season = 'SEASON',
  Renovation = 'RENOVATION',
  PropertyNotAvailable = 'PROPERTY_NOT_AVAILABLE',
  FullyBooked = 'FULLY_BOOKED',
  IssuesGuests = 'ISSUES_GUESTS',
  IssuesBooking = 'ISSUES_BOOKING',
  Strategy = 'STRATEGY',
  Other = 'OTHER',
}
